var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5604 22.0605C14.2791 22.3417 13.8977 22.4997 13.4999 22.4997C13.1022 22.4997 12.7207 22.3417 12.4394 22.0605L6.43942 16.0605C6.15822 15.7792 6.00024 15.3977 6.00024 15C6.00024 14.6023 6.15822 14.2208 6.43942 13.9395L12.4394 7.9395C12.7223 7.66626 13.1012 7.51507 13.4945 7.51849C13.8878 7.52191 14.264 7.67966 14.5422 7.95777C14.8203 8.23589 14.978 8.6121 14.9814 9.0054C14.9849 9.39869 14.8337 9.7776 14.5604 10.0605L11.1209 13.5H22.4999C22.8977 13.5 23.2793 13.658 23.5606 13.9393C23.8419 14.2206 23.9999 14.6022 23.9999 15C23.9999 15.3978 23.8419 15.7794 23.5606 16.0607C23.2793 16.342 22.8977 16.5 22.4999 16.5H11.1209L14.5604 19.9395C14.8416 20.2208 14.9996 20.6023 14.9996 21C14.9996 21.3977 14.8416 21.7792 14.5604 22.0605Z",
    fill: "#999BAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.517f1940357b9869c90dfff809f4fb0c.svg";
export { ForwardRef as ReactComponent };